import { render } from "./LinkReferido.vue?vue&type=template&id=0f385d20"
import script from "./LinkReferido.vue?vue&type=script&lang=js"
export * from "./LinkReferido.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__